import { useAbility } from "@casl/react";
import type { ReactNode } from "react";

import type { ActionsForRole } from "@/api/admin/roleManagment";
import { NoPermissionFallback } from "@/components/atoms";
import { AbilityContext } from "@/services/casl/AbilityProvider";
import type { AbilityAppSections } from "@/types/common";

interface Props {
  action: ActionsForRole;
  subject: AbilityAppSections;
  children: ReactNode;
  fallback?: ReactNode;
}

export const PermissionGuard = ({
  action,
  subject,
  children,
  fallback,
}: Props) => {
  const ability = useAbility(AbilityContext);

  const allowed = ability.can(action, subject);

  if (!allowed) {
    return fallback ?? <NoPermissionFallback />;
  }

  return <>{children}</>;
};
